/**
 * Determine whether an object is an error atom
 * @param {*} value The object to test
 * @return {boolean} Whether the object is an error atom
 */
function isError(value) {
  return Boolean(value) && (value.$type === 'error');
}

module.exports = isError;
